import { MessageSquare, Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import { API_URL } from '../../config/api'

interface Props {
  agentId: number
}

export default function AgentConversationsTab({ agentId }: Props) {
  const [messages, setMessages] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch(`${API_URL}/api/agents/${agentId}/inbox`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(r => r.ok ? r.json() : { messages: [] })
      .then(d => { setMessages(d.messages ?? d.inbox ?? []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [agentId])

  const filtered = search
    ? messages.filter(m => (m.content ?? '').toLowerCase().includes(search.toLowerCase()))
    : messages

  if (loading) return <div className="ad-loading">Loading conversations...</div>

  return (
    <div className="ad-conversations">
      {/* Search */}
      <div className="ad-search-bar">
        <Search size={14} />
        <input
          type="text"
          placeholder="Search messages..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {filtered.length === 0 ? (
        <div className="ad-empty"><MessageSquare size={32} /><p>No conversations yet</p></div>
      ) : (
        <div className="ad-msg-list">
          {filtered.slice(0, 50).map((m, i) => (
            <div key={m.id ?? i} className="ad-msg-row">
              <div className="ad-msg-content">{(m.content ?? '').slice(0, 200)}</div>
              <div className="ad-msg-meta">
                {m.sender_name && <span className="ad-msg-sender">{m.sender_name}</span>}
                {m.eq_score != null && <span className="ad-msg-eq">EQ {Number(m.eq_score).toFixed(1)}</span>}
                {m.created_at && <span className="ad-msg-time">{new Date(m.created_at).toLocaleDateString()}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
